import { parseISO, format } from 'date-fns';
import { IOrderNarvarShipment } from 'src/api/OrderTrackingApiSdk';
import { INVALID_DATE } from './Constants';

export const formatDate = (originalDate: string, dateFormatPattern: string) => {
    const date = parseISO(originalDate);
    let dateStr = '';
    if (date.toString() !== INVALID_DATE) {
        try {
            dateStr = format(date, dateFormatPattern);
        } catch {
            dateStr = '';
        }
    }

    return dateStr;
};

export const formatOrderDate = (formatedDate: string, datetimeFormatPattern: string) => {
    if (formatedDate) {
        const dateStr = format(new Date(formatedDate), datetimeFormatPattern);

        return dateStr;
    }
};

export const getUpdatedOrder = (inputArray: IOrderNarvarShipment[]) => {
    const today = new Date().getTime();
    const result = inputArray.sort((a, b) => {
        const diffA = new Date(a.status_timestamp).getTime() - today;
        const diffB = new Date(b.status_timestamp).getTime() - today;

        return diffB - diffA;
    })[0];

    return result;
};
